import React from "react"

import Detail from "../components/detail"

const DetailPage = ({pageContext}) => (
    <Detail slug={pageContext.slug} />
)

export default DetailPage
